import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir5471ScheduleOService {

  constructor(private http: HttpClient) { }

  saveScheduleO(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleDetails: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {

    let params: any = {};
    
    const globalParams = globalService?.globalParams || {};
    params.tax_year = filterParams.tax_year || globalParams.tax_year;
    params.scenario = filterParams.scenario || globalParams.scenario;
    params.jcd_key = filterParams.jcd_key || globalParams.jcd_key || 250;
    params.screen_key = filterParams.screen_key || globalParams.screen_key;
    params.jcd_ta_key = filterParams.jcd_ta_key || globalParams.jcd_ta_key;
    params.activity_key = filterParams.activity_key || globalParams.activity_key;
    params.screen_type = filterParams.screen_type || globalParams.screen_type || "grid";
    params.is_locked = filterParams.is_locked || globalParams.is_locked || "N";
    
    params.jsonObj = JSON.stringify(scheduleDetails);        // EXACT: matches line 138 of AngularJS service
    params.jsonSettings = JSON.stringify(scheduleSettings);  // EXACT: matches line 137 of AngularJS service
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || "RAF";
    params.is_issue_key_enabled = "N";
    
    console.log('🔧 SERVICE: Building payload with essential params only');
    console.log('  jsonObj length:', params.jsonObj.length);
    console.log('  jsonSettings length:', params.jsonSettings.length);
    console.log('  Essential params:', {
      tax_year: params.tax_year,
      scenario: params.scenario,
      jcd_key: params.jcd_key,
      screen_key: params.screen_key
    });

    const checkLockedbj = [{
      "leid": rowData.LEID,
      "cdr_number": rowData.CDR_NO,
      "consol_group_key": rowData.CONSOL_GROUP_KEY,
      "reporting_period": rowData.REPORTING_PERIOD,
      "combination_key": rowData.HO_COMBINATION_KEY,
      "scenario_key": parseInt(filterParams.scenario || params.scenario)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    params.process_name = "Schedule_O_Save";

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = baseUrl + '/saveJsonObject?action_code=6qr0av';

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  loadScheduleData(
    baseUrl: string,
    actionCode: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params.combination_key = rowData.HO_COMBINATION_KEY;

    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    const url = baseUrl + `/loadJsonObject?action_code=${actionCode}&${urlParams.toString()}`;

    return this.http.get<any>(url, { withCredentials: true });
  }
}

